export const BASE_URL = `https://api.purebrand.io`;
export const SHOPIFY_URL = `https://app.purebrand.io`;

// export const BASE_URL = `http://192.168.1.4:8000`;

export const DOTS_CONNECT_STATUS = {
  NOT_CONNECTED: 'Not Connected',
  UNVERIFIED: 'Unverified',
  INCOMPLETE_FLOW: 'Incomplete Flow',
  COMPLETE_FLOW: 'Complete Flow',
};

export const TEST_ROLES = {
  COMBOBOX: 'combobox',
  OPTION: 'option',
};

export const DEMO_HISTORY_STATUS = {
  SUCCESS: 'Success',
  GUEST_NO_SHOW: 'Guest No Show',
  UNDER_TIME: 'Under Time',
  BACKUP_SUCCESS: 'Back-Up Success',
  SALE_PENDING: 'Sale Pending',
  SALE_FULFILLED: 'Sale Fulfilled',
  SALE_CANCELLED: 'Sale Canceled',
  HOST_NO_SHOW: 'Host No Show',
  PROCESSING : 'Processing',
  OFF_TOPIC: 'Off Topic',
  TECH_DIFF: 'Tech Diff',
  OBSCENE_CONTENT: 'Obscene Content',
};

export const MODERATION_STATUS_POLL_MS = 8000;

export const DATES_FILTER = [
  { label: 'Today', value: 'today' },
  { label: 'Last 7 Days', value: 'week' },
  { label: 'Last 14 Days', value: 'biweek' },
  { label: 'Last 30 Days', value: 'month' },
  { label: 'Pay Period', value: 'payperiod' },
  { label: 'Custom', value: 'custom' },
];

export const COMMISSION_FILTER = [
  { label: 'Video meeting', value: 'Demo' },
  {label: 'No-Show', value: 'No-Show'},
  { label: 'Sales', value: 'Sales' },
];
export const DATE_FORMATS = {
  GENERIC_DATE_FORMAT: 'YYYY-MM-DD',
  GENERIC_UTC_DATE_FORMAT: 'YYYY-M-DTHH:mm',
  GENERIC_UTC_TIME_FORMAT: 'hh:mm A',
  GENERIC_FULL_DATE_FORMAT: 'YYYY-M-DTHH:mm:ss',
  MY_PAYOUTS_DATE_FORMAT: 'ddd MMM DD YYYY',
  MEETING_STATUS_DATE_FORMAT: 'MM/DD/YYYY'
};

export const SORTING_STATUS = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  NONE: 'none',
};

export const APP_STATUS = {
  CREATED: 'created',
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
};

export const GENERIC_ERROR_MESSAGE = 'Something went wrong';

export const US_STATE_LIST = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansa', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Lousiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

export const INCORPORATION_TYPES = [
  {
    label: 'Sole proprietorship',
    value: 'sole_proprietorship',
  },
  {
    label: 'Partnership',
    value: 'partnership',
  },
  {
    label: 'Limited Liability Company',
    value: 'llc',
  },
  {
    label: 'C Corporation',
    value: 'c_corporation',
  },
  {
    label: 'S Corporation',
    value: 's_corporation',
  },
];

export const COUNTRY_OPTIONS = [
  {
    label: 'United States',
    value: 'United States',
  },
];

export const DEMO_STATUS_OPTIONS = {
  UNDECIDED: 'UNDECIDED',
  ACCEPTED: 'ACCEPTED',
  STARTED: 'STARTED',
  DECLINED: 'DECLINED',
};

export const failedStatuses = [
  'card_declined',
  'payment_blocked',
  'expired_card',
  'error_creating_intent',
  'payout_failed',
  'failed',
];

/**
 * Feature codes used by the entitlement gates.
 *
 * These name capabilities, not plans. Which plans grant them is data the backend
 * owns, so a plan launching or a feature moving between tiers never touches this
 * file. Plan names deliberately do not appear anywhere in the frontend.
 */
export const FEATURES = {
  MEETINGS_LIMIT: 'meetings_limit',
  HOSTS_LIMIT: 'hosts_limit',
  SHOPIFY_SYNC: 'shopify_sync',
  REVIEW_HOST_LOOP: 'review_host_loop',
  HOST_PAYOUTS_STORE_CREDIT: 'host_payouts_store_credit',
  GROUP_MEETINGS: 'group_meetings',
  AI_SUMMARY: 'ai_summary',
  INSIGHTS_SENTIMENT: 'insights_sentiment',
  INSIGHTS_PROS_CONS: 'insights_pros_cons',
  INSIGHTS_EMAIL: 'insights_email',
  SALES_OBJECTION_INTELLIGENCE: 'sales_objection_intelligence',
};

/**
 * Plan changes that are not self-serve and are raised with the support team
 * instead. Mirrors the request types the backend accepts.
 */
export const SUPPORT_REQUEST_TYPES = {
  ENTERPRISE_ENQUIRY: 'ENTERPRISE_ENQUIRY',
  DOWNGRADE: 'DOWNGRADE',
};

export const SUBSCRIPTION_MODAL_ACTIONS = {
  SELECT: 'Select',
  UPDATE: 'Update',
  CANCEL: 'Cancel',
  UPGRADE: 'Upgrade',
};

export const SUBSCRIPTION_STATUS = {
  NOT_INITIATED: 'NOT_INITIATED',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  CANCELLED: 'CANCELLED',
  BLOCKED: 'BLOCKED',
  ENDED: 'ENDED',
  UPGRADED: 'UPGRADED',
};

export const SUBSCRIPTION_ACTION_TYPE = {
  PAUSE: 1,
  RESUME: 2,
};

export const LANDING_IMAGE = {
LANDING_FIRST_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/landing_first_img.svg",
LANDING_SECOND_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/landing_second_img.svg",
LANDING_THIRD_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/landing_third_img.svg",
LANDING_PAGE_CLYDE_BAKER_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/clyde_barker.jpeg",
LANDING_PAGE_GRETTA_STANLEY_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/gretta_stanley.jpeg",
LANDING_PAGE_KENNEDY_SMITH_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/kennedy_smith.png",
LANDING_PAGE_TESTIMONIAL_DAVID_BAILEY_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/testimonial_david_bailey.jpeg",
LANDING_PAGE_TESTIMONIAL_JAVIER_MORALES_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/testimonial_javier_morales.jpeg",
LANDING_PAGE_TESTIMONIAL_KAREN_THOMAS_IMAGE:"https://purebrand-storage.s3.us-east-2.amazonaws.com/landing_image/testimonial_karen_thomas.jpeg"
}
export const DEMO_RECORDING_TYPE = {
  MIXED: 'MIXED',
  HOST: 'HOST',
  GUEST: 'GUEST',
};

export const GUEST_DEMO_CANCEL_RESCHEDULE_STATUS = {
  CANCELLED: "Video meeting canceled successfully. Please check your email for confirmation.",
  CANCELLED_ERROR: "Could not cancel the demo. Something went wrong.",
  RESCHEDULED_ERROR: "Something went wrong while rescheduling. Please try again.",
  REDIRECTING: "Video meeting Status updated and please wait we're sending you to reschedule page.",
  REDIRECTING_ERROR: "Something went wrong while redirecting to reschedule page. Contact Store",
  
}

// ROLES CONSTANTS
// 1 - Purebrand Admin
// 2 - Store Admin
// 3 - Host
// 4 - Owner
// 5 - View Only
// 6 - Edit Admin
// 7 - Customer Support
// 8 - Accountant

// `label` is the role's short name; `portalLabel` is the status line shown
// under the logo in the sidebar. What a role may *do* is never encoded here:
// that comes from the backend as capabilities (see utils/capabilities.js).
export const ROLES = {
  PUREBRAND_ADMIN: {
    role: 1,
    label: 'Purebrand Admin',
    portalLabel: 'Purebrand Admin',
  },
  STORE_ADMIN: {
    role: 2,
    label: 'Store Admin',
    portalLabel: 'Store Admin',
  },
  HOST: {
    role: 3,
    label: 'Host',
    portalLabel: 'Real Customer',
  },
  OWNER: {
    role: 4,
    label: 'Owner',
    portalLabel: 'Store Admin (Owner)',
  },
  EDIT_ADMIN: {
    role: 6,
    label: 'Edit Admin',
    portalLabel: 'Store Admin (Edit Admin)',
  },
  VIEW_ONLY: {
    role: 5,
    label: 'View Only',
    portalLabel: 'Store Admin (Viewer)',
  },
  CUSTOMER_SUPPORT: {
    role: 7,
    label: 'Customer Support',
    portalLabel: 'Customer Support',
  },
  ACCOUNTS: {
    role: 8,
    label: 'Accountant',
    portalLabel: 'Store Accountant',
  }
};

/**
 * Look a role up by its numeric value.
 *
 * @param {Number} role role value from the login payload
 * @returns {Object|undefined} the ROLES entry
 */
export const getRoleByValue = (role) =>
  Object.values(ROLES).find((entry) => entry.role === Number(role));

export const HAS_DISCUSSED_BUSINESS = {
  NA:"NOT_APPLICABLE",
  NI:"NOT_INITIATED",
  IP:"IN_PROGRESS",
  FIN:"FINISHED"
}

// Meeting Takeaways Constants
export const MEETING_TAKEAWAYS_TABS = {
  FAQS: 'faqs',
  HOST: 'host',
  GUEST: 'guest'
};

export const PROS_CONS_TOGGLE = {
  PROS: 'pros',
  CONS: 'cons'
};

export const USER_TYPES = {
  HOST: 'HOST',
  GUEST: 'GUEST'
};

export const API_ENDPOINTS = {
  GET_UNIQUE_QUESTIONS: '/api/v1/get-unique-questions/',
  GET_UNIQUE_PROS_CONS: '/api/v1/get-unique-pros-cons/'
};

export const NO_DATA_MESSAGE = 'No more data to load.';

// Video Meeting Permission Modal Constants
export const VIDEO_MEETING_PERMISSION_MODAL = {
  TITLE: 'Permission Required',
  MESSAGE: 'Apple devices require a user interaction to start audio and video streams. Please click "Proceed" to enable your camera and microphone for the meeting. This helps in ensuring a smooth video experience.',
  BUTTON_TEXT: 'Proceed'
};
